/**
 * Check to see whether the value is a number
 */

export default function isInteger(value) {
  return (
    !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value // eslint-disable-line eqeqeq
  );
}
